import React from 'react';
import styles from './FilterSection.module.css';

const FINANCIAL_YEARS = ['Complete', 'FY 2024-25', 'FY 2025-26'];

const SALES_PERSONS = [
  { code: '21', name: 'Aditya Deshpande' },
  { code: '22', name: 'Ashish Tripathi' },
  { code: '20', name: 'Ashwani Sharma' },
  { code: '1', name: 'Bhavani Shanker' },
  { code: '6', name: 'Christy Samuel' },
  { code: '12', name: 'Dr. Prashant Kadam' },
  { code: '18', name: 'Hemanth V' },
  { code: '3', name: 'J Dinesh kumar' },
  { code: '13', name: 'Jagadish Naidu M' },
  { code: '14', name: 'Kamal Kurra' },
  { code: '8', name: 'Mahesh Shegar' },
  { code: '11', name: 'Maneesh S' },
  { code: '-1', name: '-No Sales Employee-' },
  { code: '7', name: 'Pratik Patil' },
  { code: '17', name: 'Pratiksha Dabhane' },
  { code: '16', name: 'R Kalyan Babu' },
  { code: '10', name: 'Raghu B' },
  { code: '2', name: 'RAMAKRISHNAN SUNDARAM' },
  { code: '15', name: 'Ravindra Patil' },
  { code: '5', name: 'Saroj Kumar Purohit' },
  { code: '4', name: 'Satish Nagaraj' },
  { code: '9', name: 'Shafique' },
];

const REGIONS = [
  'Overseas',
  'Central',
  'South',
  'West 1',
  'North',
  'West 2',
  'East',
];

const STATES = [
  'Overseas',
  'Telangana',
  'Maharashtra',
  'Tamil Nadu',
  'Uttar Pradesh',
  'Gujarat',
  'Karnataka',
  'Madhya Pradesh',
  'West Bengal',
  'Delhi',
  'Goa',
  'Andhra Pradesh',
  'Punjab',
  'Haryana',
  'Rajasthan',
  'Jharkhand',
  'Kerala',
  'Uttarakhand',
  'Assam',
  'Himachal Pradesh',
  'Chandigarh',
];

const FilterSection = ({
  selectedYear,
  setSelectedYear,
  selectedSalesPerson,
  setSelectedSalesPerson,
  selectedRegion,
  setSelectedRegion,
  selectedState,
  setSelectedState,
  onReset,
}) => {
  return (
    <div className={styles.filterSection}>
      <div className={styles.filterGrid}>
        {/* Financial Year Dropdown */}
        <div className={styles.filterItem}>
          <label className={styles.label}>
            Financial Year <span className={styles.required}>*</span>
          </label>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className={`${styles.select} ${selectedYear ? styles.selectFilled : ''}`}
          >
            {FINANCIAL_YEARS.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        {/* Sales Person Dropdown */}
        <div className={styles.filterItem}>
          <label className={styles.label}>Sales Person</label>
          <select
            value={selectedSalesPerson}
            onChange={(e) => setSelectedSalesPerson(e.target.value)}
            className={`${styles.select} ${selectedSalesPerson ? styles.selectFilled : ''}`}
          >
            <option value="">Select Sales Person</option>
            {SALES_PERSONS.map((sp) => (
              <option key={sp.code} value={sp.code}>
                {sp.name}
              </option>
            ))}
          </select>
        </div>

        {/* Region Dropdown */}
        <div className={styles.filterItem}>
          <label className={styles.label}>Region</label>
          <select
            value={selectedRegion}
            onChange={(e) => setSelectedRegion(e.target.value)}
            className={`${styles.select} ${selectedRegion ? styles.selectFilled : ''}`}
          >
            <option value="">Select Region</option>
            {REGIONS.map((region) => (
              <option key={region} value={region}>
                {region}
              </option>
            ))}
          </select>
        </div>

        {/* State Dropdown */}
        <div className={styles.filterItem}>
          <label className={styles.label}>State</label>
          <select
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
            className={`${styles.select} ${selectedState ? styles.selectFilled : ''}`}
          >
            <option value="">Select State</option>
            {STATES.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>

        {/* Reset Button */}
        <div className={styles.filterItem}>
          <div className={styles.resetWrapper}>
            <button onClick={onReset} className={styles.resetButton}>
              <span className={styles.resetIcon}>🔄</span>
              Reset Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;